import React, { Fragment, useEffect, useState } from 'react';
// import SearchHeader from "./searchHeader";
import UserMenu from './user-menu';
import { AlignLeft, Maximize2, MoreHorizontal } from 'react-feather';
import { useHistory } from 'react-router-dom';
//images
import logo from '../../../assets/images/dashboard/treasure-logo.png';
import { socket } from '../../../config/socket';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { adminInstance } from '../../../config/axios';
import NotificationsList from './NotificationsList.jsx';
import {setShowProfile} from '../../../reducers/adminReducers.js';

const Header = () => {
    const dispatch = useDispatch();
  
  const result = useSelector((state) => state.admin);
  const {isShowProfile} = useSelector(state=>state.admin)
  const { loginAdmin } = result || {};
  const [sidebar, setSidebar] = useState(true);
  // const [navMenus, setNavMenus] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [notificationMenu, setNotificationMenu] = useState({});
  const [skip, setSkip] = useState(6);
  const [notificationLoader, setNotificationLoader] = useState(false);
  const history = useHistory();
  const handleNavigate = (pageName) => {history.push(`/${pageName || 'supportChatManagement'}`)};

  const toggle = () => {
    dispatch(setShowProfile(true));   
    //  setNavMenus((prevState) => ({
    //   navMenus: !prevState.navMenus,
    // }));
  };

  const goFull = () => {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };
  const openCloseSidebar = () => {
    if (sidebar) {
      setSidebar(false);
      document.querySelector('.page-main-header').classList.add('open');
      document.querySelector('.page-sidebar').classList.add('open');
    } else {
      setSidebar(true);
      document.querySelector('.page-main-header').classList.remove('open');
      document.querySelector('.page-sidebar').classList.remove('open');
    }
  };
  const updateReadTypeMessageAPI = async () => {
    try {
      const response = await adminInstance().get(
        '/api/admin/updateReadTypeMessage'
      );
      return response?.data;
    } catch (error) {
      return error?.response?.data;
    }
  };

  const dismissAPI = async (notificationId) => {
    try {
      const response = await adminInstance().post('/api/admin/dismissAPI', {
        notificationId,
      });
      return response?.data;
    } catch (error) {
      return error?.response?.data;
    }
  };

  const dismissAllAPI = async () => {
    try {
      const response = await adminInstance().get('/api/admin/dismissAll');
      return response?.data;
    } catch (error) {
      return error?.response?.data;
    }
  };
  const fetchMoreData = () => {
    setSkip((prev) => prev + 6);
  };

  const updateReadTypeMessage = async () => {
    await updateReadTypeMessageAPI();
  };

  const handleNotificationToggle = () => {
    if (showNotification === false) {
      updateReadTypeMessage();
      setCount(0);
    }
    setShowNotification((prev) => !prev);
  };

  const dismissAll = async () => {
    setNotificationLoader(true);
    const response = await dismissAllAPI();
    if (response.code === 200) {
      setNotificationLoader(false);
      setNotifications([]);
      setCount(0);
      setTotalCount(0);
      setSkip(6);
    } else {
      setNotificationLoader(false);
      toast.error(response.message, { id: 'error-deleting-the-notifications' });
    }
  };

  const dismiss = async (id) => {
    setNotificationLoader(true);
    const response = await dismissAPI(id);
    if (response.code === 200) {
      setNotificationLoader(false);
      const newFilterData = notifications.filter((ele) => {
        if (ele.notificationId !== id) {
          return true;
        } else {
          return false;
        }
      });
      setNotifications(newFilterData);
    } else {
      setNotificationLoader(false);
      toast.error(response.message, { id: 'error-in-dismiss-feature' });
    }
  };

  const getNotifications = async (skip, cancelToken) => {
    try {
      const response = await adminInstance().post(
        '/api/admin/getAdminNotifications',
        { skip },
        { cancelToken }
      );
      return response?.data;
    } catch (error) {
      return error?.response?.data;
    }
  };

  useEffect(() => {
    if (loginAdmin?._id) {
      const source = axios.CancelToken.source();
      const getNotificationsCall = async () => {
        const response = await getNotifications(skip, source.token);
        if (response?.code === 200) {
          setTotalCount(response.totalCount);
          setCount(response.unreadCount);
          setNotifications(response.notifications);
          setNotificationMenu(response.sideMenu);
        } else if (response) {
          toast.error('Error fetching the notifications', {
            id: 'error-fetching-notifications',
          });
        }
      };
      getNotificationsCall();

      return () => {
        source.cancel('Request cancelled');
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip]);

  useEffect(() => {
    socket.on('adminNotify', (data) => {
      if (data.type !== 'cardSetup' || data.type !== 'cardTransaction') {
        setNotifications((prev) => [data.payload, ...prev]);
      }
      switch (data.type) {
        case 'supportChatNotify':
          setNotificationMenu((prev) => ({
            ...prev,
            supportChatNotify: prev.supportChatNotify + 1,
          }));
          break;
        default:
          console.log('No Specific matches for Admin Notify Type');
      }
      if (
        !showNotification &&
        data.type !== 'cardSetup' &&
        data.type !== 'cardTransaction'
      ) {
        setCount((prev) => prev + 1);
      }
    });
    return () => {
      socket.off('adminNotify');
    };
  }, [count, showNotification, notificationMenu, setNotificationMenu]);

  return (
    <Fragment>
      {/* open */}
      <div className='page-main-header '>
        <div className='main-header-right row'>
          <div className='main-header-left d-lg-none'>
            <div className='logo-wrapper logo2'>
              <a href='index.html'>
                <img className='blur-up lazyloaded' src={logo} alt='' />
              </a>
            </div>
          </div>
          <div className='mobile-sidebar'>
            <div className='media-body text-right switch-sm'>
              <label className='switch'>
                <a href='##' onClick={openCloseSidebar}>
                  <AlignLeft />
                </a>
              </label>
            </div>
          </div>
          <div className='nav-right col'>
            <ul className={'nav-menus px-20 justifuEnd ' + (isShowProfile ? 'open' : '')}>
            {/* <ul className={'nav-menus open'}> */}
              <li>{/* <SearchHeader /> */}</li>
              <li>
                <a href='##' onClick={goFull} className='text-dark'>
                  <Maximize2 />
                </a>
              </li>
              <li>
                <div className='text-dark'>
                  <NotificationsList
                    notifications={notifications}
                    showNotification={showNotification}
                    setShowNotification={setShowNotification}
                    count={count}
                    totalCount={totalCount}
                    skip={skip}
                    fetchMoreData={fetchMoreData}
                    dismiss={dismiss}
                    notificationLoader={notificationLoader}
                    handleNavigate={handleNavigate}
                    dismissAll={dismissAll}
                    handleNotificationToggle={handleNotificationToggle}
                  />
                </div>
              </li>
              <UserMenu />
            </ul>
            <div
              className='d-lg-none mobile-toggle pull-right'
              onClick={() => toggle()}
            >
              <MoreHorizontal />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
